import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export const SOCIAL_NETWORKS: ReadonlyArray<
	Readonly<{
		id: string;
		href: string;
		name: TranslationKey;
		handle: TranslationKey;
	}>
> = [
	{
		id: 'instagram',
		href: 'https://www.instagram.com/changedotorg/',
		name: translationKey('corgi.press_page.social.networks.instagram.name'),
		handle: translationKey('corgi.press_page.social.networks.instagram.handle'),
	},
	{
		id: 'tiktok',
		href: 'https://www.tiktok.com/@changedotorg',
		name: translationKey('corgi.press_page.social.networks.tiktok.name'),
		handle: translationKey('corgi.press_page.social.networks.tiktok.handle'),
	},
	{
		id: 'x',
		href: 'https://twitter.com/Change',
		name: translationKey('corgi.press_page.social.networks.x.name'),
		handle: translationKey('corgi.press_page.social.networks.x.handle'),
	},
	{
		id: 'facebook',
		href: 'https://www.facebook.com/change.org',
		name: translationKey('corgi.press_page.social.networks.facebook.name'),
		handle: translationKey('corgi.press_page.social.networks.facebook.handle'),
	},
	{
		id: 'linkedin',
		href: 'https://www.linkedin.com/company/change-org/',
		name: translationKey('corgi.press_page.social.networks.linkedin.name'),
		handle: translationKey('corgi.press_page.social.networks.linkedin.handle'),
	},
];
